module.exports = __webpack_public_path__ + "static/media/paragon-innovation-summit-mobile.578ef642.jpg";